const NumberHelper = () => {
    return {
        formatCurrency(number, preffix = '', suffix = '', separator = ',') {
            const formatted = Number(number).toFixed(2);
            return `${preffix}${formatted.replace(/\./g, separator)}${suffix}`;
        },
        parseInt(value) {
            const parsed = parseInt(value, 10);
            return Number.isNaN(parsed) ? null : parsed;
        }
    };
};

export default NumberHelper();
